var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"full"},[_c('div',{ref:"mounter",staticClass:"full"}),_c('Scene',{on:{"ready":(v) => { _vm.scene = v; _vm.init() }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }